import { Link } from "react-router-dom";
import { channels } from "@/mocks/channels";
import { siteInfo } from "@/mocks/site";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer id="footer-contact" className="mt-20 bg-accent-950 text-accent-100">
      <div className="mx-auto max-w-[1280px] px-6 py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-sm font-bold text-background-50">
                51
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-accent-200/90">
              以栏目导航为入口的内容门户，聚合深度调查、实时热点与消费生活类内容，帮你在最短时间内定位想看的板块。
            </p>
            <p className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-accent-900 px-3 py-1.5 text-xs text-accent-100">
              <i className="ri-map-pin-line" />
              内容团队 · 在线协作
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50">内容板块</h4>
            <ul className="mt-4 space-y-2.5">
              {channels.slice(0, 5).map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/pindao/${c.slug}`}
                    className="flex items-center gap-2 text-sm text-accent-200/90 transition-colors hover:text-background-50"
                  >
                    <i className="ri-arrow-right-s-line text-primary-400" />
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50">站点导航</h4>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/lanmu" className="flex items-center gap-2 text-sm text-accent-200/90 transition-colors hover:text-background-50">
                  <i className="ri-arrow-right-s-line text-primary-400" />
                  栏目导航
                </Link>
              </li>
              <li>
                <Link to="/changjianwenti" className="flex items-center gap-2 text-sm text-accent-200/90 transition-colors hover:text-background-50">
                  <i className="ri-arrow-right-s-line text-primary-400" />
                  常见问题
                </Link>
              </li>
              <li>
                <Link to="/guanyu" className="flex items-center gap-2 text-sm text-accent-200/90 transition-colors hover:text-background-50">
                  <i className="ri-arrow-right-s-line text-primary-400" />
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/lanmu" className="flex items-center gap-2 text-sm text-accent-200/90 transition-colors hover:text-background-50">
                  <i className="ri-arrow-right-s-line text-primary-400" />
                  事件专题
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50">联系与反馈</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-accent-200/90">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400" />
                {siteInfo.email}
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-primary-400" />
                微信公众号：{siteInfo.wechat}
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-global-line text-primary-400" />
                {siteInfo.domain}
              </li>
            </ul>
            <p className="mt-4 text-xs leading-relaxed text-accent-300/80">
              如发现内容存在事实偏差，欢迎通过邮箱指出，我们会核实后补充或更正说明。
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-accent-800 pt-6 text-xs text-accent-300/80 sm:flex-row">
          <p>© {year} {siteInfo.name} · 本站内容仅供参考，不构成任何专业建议</p>
          <p className="flex items-center gap-4">
            <Link to="/guanyu" className="transition-colors hover:text-background-50">内容原则</Link>
            <Link to="/changjianwenti" className="transition-colors hover:text-background-50">使用帮助</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}